"use client"

import { useMounted } from "@/hooks"
import * as Portal from "@radix-ui/react-portal"

import { Img } from "./image"

const Loader = ({ fullscreen = true }: { fullscreen?: boolean }) => {
  const mounted = useMounted()

  if (!mounted) return null

  return fullscreen ? (
    <Portal.Root>
      <div className="loader bg-loader fixed inset-0 z-100 flex items-center justify-center">
        <Img
          className="animate-spin"
          alt="Loader icon"
          src={"/loader.svg"}
          width={60}
          height={60}
          priority={true}
          placeholder={"empty"}
        />
      </div>
    </Portal.Root>
  ) : (
    <div className="flex items-center justify-center p-3">
      <Img
        className="animate-spin"
        alt="Loader icon"
        src={"/loader.svg"}
        width={60}
        height={60}
        priority={true}
        placeholder={"empty"}
      />
    </div>
  )
}

export { Loader }
